import React, { useState, useEffect } from 'react';
import { Button, Text, Group, Loader, Center, Chip } from '@mantine/core';
import { IconBrandSlack, IconPlugConnected, IconPlugConnectedX } from '@tabler/icons-react';
import fetchApi from '../components/Lib/api';
import Mixpanel from '../components/Lib/mixpanel';

const SlackConnection = ({filter, setFilter}) => {
  const [isConnected, setIsConnected] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [feedbackMessage, setFeedbackMessage] = useState(null);
  const [isErrorFeedback, setIsErrorFeedback] = useState(false);

  const checkSlackStatus = async () => {
    setIsLoading(true);
    setFeedbackMessage(null);
    setIsErrorFeedback(false);
    try {
      const response = await fetchApi('/auth/slack_status', 'GET');
      if (response.ok) {
        const data = await response.json();
        setIsConnected(data.connected);
      } else {
        const errorData = await response.json();
        setFeedbackMessage(errorData.error || 'Failed to check Slack connection status.');
        setIsErrorFeedback(true);
        setIsConnected(false);
      }
    } catch (err) {
      setFeedbackMessage('Network error or server unreachable for status check.');
      setIsErrorFeedback(true);
      setIsConnected(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkSlackStatus();

    const urlParams = new URLSearchParams(window.location.search);
    const slackConnectSuccess = urlParams.get('slack_connect');
    const slackConnectError = urlParams.get('slack_error');
    const slackDisconnectSuccess = urlParams.get('slack_disconnect');

    if (slackConnectSuccess === 'true') {
      setFeedbackMessage('Slack connected successfully!');
      setIsErrorFeedback(false);
      checkSlackStatus();
    } else if (slackDisconnectSuccess === 'true') {
      setFeedbackMessage('Slack disconnected successfully.');
      setIsErrorFeedback(false);
      checkSlackStatus();
    } else if (slackConnectError) {
      setFeedbackMessage(`Slack connection failed: ${slackConnectError}`);
      setIsErrorFeedback(true);
      setIsConnected(false);
    }

    if (slackConnectSuccess || slackConnectError || slackDisconnectSuccess) {
      const newUrlParams = new URLSearchParams(window.location.search);
      newUrlParams.delete('slack_connect');
      newUrlParams.delete('slack_error');
      newUrlParams.delete('slack_disconnect');

      window.history.replaceState({}, document.title, `${window.location.pathname}?${newUrlParams.toString()}`);
    }
  }, []);

  const handleConnectSlack = () => {
    setIsLoading(true);
    setFeedbackMessage(null);
    setIsErrorFeedback(false);
    const redirectBackTo = "/dashboard/#/messages"
    window.location.href = `/auth/slack?redirect_to=${encodeURIComponent(redirectBackTo)}`;
  };

  return (
    <Center>
        {isConnected ? (
          <Chip
            checked={filter === "slack"}
            onClick={() => {
              setFilter("slack");
              Mixpanel.button('View Slack Messages', {
                location: 'Integrations Filter',
                status: 'connected',
                is_loading: isLoading
              });
            }}
            disabled={isLoading}
            className="w-full"
          >
            Slack
          </Chip>
        ) : (
          <Chip
          checked={filter === "slack"}
            onClick={() => {
              handleConnectSlack();
              Mixpanel.button('Connect Slack', {
                location: 'Integrations Filter',
                status: 'not_connected',
                is_loading: isLoading
              });
            }}
            disabled={isLoading}
            className="w-full"
          >
           Slack
          </Chip>
        )}
      </Center>
  );
};

export default SlackConnection;